"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetInstanceManager = void 0;
var WidgetInstanceManager = /** @class */ (function () {
    function WidgetInstanceManager(configuration, httpClient) {
        this.configuration = configuration;
        this.httpClient = httpClient;
    }
    WidgetInstanceManager.prototype.getInstanceURL = function (widgetInstanceId) {
        var configuration = this.configuration;
        return "https://" + configuration.domain + "/_api/widgetInstances/" + widgetInstanceId;
    };
    WidgetInstanceManager.prototype.getAuthURL = function (widgetInstanceId) {
        return this.getInstanceURL(widgetInstanceId) + "/auth";
    };
    WidgetInstanceManager.prototype.auth = function (widgetInstanceId) {
        return this.httpClient
            .get(this.getAuthURL(widgetInstanceId))
            .then(function (response) { return response.payload.token; }, function (error) {
            // tslint:disable-next-line
            console.error('Error while auth', error);
            return '';
        });
    };
    WidgetInstanceManager.prototype.fetchWidgetInstance = function (widgetInstanceId) {
        var httpClient = this.httpClient;
        var instanceURL = this.getInstanceURL(widgetInstanceId);
        return httpClient
            .get(instanceURL)
            .then(function (response) { return response.payload; })
            .catch(function (error) {
            // tslint:disable-next-line
            console.error('error while fetching widget instance id', error);
            throw error;
        });
    };
    return WidgetInstanceManager;
}());
exports.WidgetInstanceManager = WidgetInstanceManager;
//# sourceMappingURL=widget-instance-manager.js.map